
import { SUPABASE_URL } from '@/utils/supabaseConfig';
import { getApiHeaders, handleApiError } from './apiUtils';

// Получение данных велосипедов для объединения с арендами
export const fetchBikesForRentals = async (): Promise<{ data: any[] | null; error: any }> => {
  try {
    const response = await fetch(`${SUPABASE_URL}/rest/v1/bikes?select=id,model,serial_number`, {
      method: 'GET',
      headers: getApiHeaders()
    });
    
    if (!response.ok) {
      return await handleApiError(response);
    }
    
    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    return { data: null, error: null };
  }
};

// Обновление статуса велосипеда
export const updateBikeStatus = async (
  bikeId: string, 
  status: string
): Promise<{ success: boolean; error: any }> => {
  try {
    const response = await fetch(`${SUPABASE_URL}/rest/v1/bikes?id=eq.${bikeId}`, {
      method: 'PATCH',
      headers: {
        ...getApiHeaders(),
        'Prefer': 'return=minimal'
      },
      body: JSON.stringify({ status })
    });
    
    if (!response.ok) {
      const { error } = await handleApiError(response);
      return { success: false, error };
    }
    
    return { success: true, error: null };
  } catch (error) {
    return { success: false, error };
  }
};
